import React, { FC } from 'react';
import { Section } from '../../layout/Section';
import { Layout } from '../../layout/Layout';
import {
  Header,
  Title,
  TagContainer,
  AuthorContainer,
  Container,
} from './PageHeader.styles';
import TagsBlock from '../../blocks/TagsBlock';
import { TagType } from '../../../old/storyblok/tags-context';
import { AuthorType } from '../../../old/storyblok/authors-context';
import AuthorMeta from '../../components/AuthorMeta';
import ScrollableFadeWrapper from '../../shared/ScrollableFadeWrapper';

export type PageHeaderProps = {
  title?: string;
  variant?: 'default' | 'xl' | 'tags' | 'xxl';
  tags?: TagType[];
  authors?: AuthorType[];
};

const PageHeaderModule: FC<PageHeaderProps> = ({
  title,
  variant,
  tags,
  authors,
}) => {
  return (
    <Section>
      <Layout>
        <Container>
          {authors && authors?.length > 0 && (
            <AuthorContainer>
              <AuthorMeta authors={authors} showBio={true} />
            </AuthorContainer>
          )}
          {title && (
            <Header className={variant}>
              <Title>{title}</Title>
            </Header>
          )}
          {tags && tags?.length > 0 && (
            <ScrollableFadeWrapper>
              <TagContainer>
                <TagsBlock tags={tags} />
              </TagContainer>
            </ScrollableFadeWrapper>
          )}
        </Container>
      </Layout>
    </Section>
  );
};

export default PageHeaderModule;
